/** kware start edit - Create action menu button for changing staff user password
 * This button appears in the user detail action menu for staff users only
 * Allows admins with reset password permission to directly change passwords
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from '@folio/stripes/components';
import { IfPermission } from '@folio/stripes/core';

const ActionMenuChangePasswordButton = ({
  onToggle,
  handleChangePasswordClick,
}) => {
  return (
    <IfPermission perm="ui-users.reset.password">
      <Button
        buttonStyle="dropdownItem"
        id="clickable-change-password"
        onClick={() => {
          handleChangePasswordClick();
          onToggle();
        }}
      >
        <Icon icon="edit">
          <FormattedMessage id="ui-users.extended.changePassword" />
        </Icon>
      </Button>
    </IfPermission>
  );
};

ActionMenuChangePasswordButton.propTypes = {
  onToggle: PropTypes.func.isRequired,
  handleChangePasswordClick: PropTypes.func.isRequired,
};

export default ActionMenuChangePasswordButton;
/** kware end edit */
